import * as React from 'react'

import type { NavigationRoutesFn } from 'modules/core/lib/react-router'

const IndexPage = React.lazy(() => import('modules/time_planning/pages/employees/IndexPage'))
const RootPage = React.lazy(() => import('modules/time_planning/pages/employees/RootPage'))

const employeesRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.employees.id.planningVersions.path,
      element: <RootPage />,
      children: [
        {
          index: true,
          element: <IndexPage />,
        },
        {
          path: navigation.employees.id.planningVersions.planningVersionId.path,
          element: <IndexPage />,
        },
      ],
    },
  ]
}

export default employeesRoutes
